import React from 'react';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutBookSection from './components/AboutBookSection';
import TargetAudienceSection from './components/TargetAudienceSection';
import BenefitsSection from './components/BenefitsSection';
import ChaptersSection from './components/ChaptersSection';
import QuotesSection from './components/QuotesSection';
import AuthorSection from './components/AuthorSection';
import ContactSection from './components/ContactSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import './App.css';

function App() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App bg-[#1a1c1b]">
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#302f2c',
            color: '#d9fb06',
            border: '1px solid #3f4816',
          },
        }}
      />
      <Header />
      <main>
        <HeroSection scrollToSection={scrollToSection} />
        <AboutBookSection />
        <TargetAudienceSection />
        <BenefitsSection />
        <ChaptersSection />
        <QuotesSection />
        <AuthorSection />
        <ContactSection />
        <CTASection scrollToSection={scrollToSection} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
